import { Toaster } from '@fluentui/react-components';

/**
 * The second Fluent toaster (COMX-FE-01): real-time notices (a new notification, an incoming
 * call) appear at the top centre, apart from the outcomes of the user's own actions which stay
 * at the bottom (`AppToaster`). `position="top"` centres the toast in every direction of writing.
 */
export const NOTICE_TOASTER_ID = 'bf-notice-toaster';

/** At most three notices are on screen at once. */
const MAX_VISIBLE_NOTICES = 3;

export function NoticeToaster() {
  return (
    <Toaster
      toasterId={NOTICE_TOASTER_ID}
      position="top"
      limit={MAX_VISIBLE_NOTICES}
      pauseOnHover
      pauseOnWindowBlur
    />
  );
}
